import { WS_DOMAIN } from '../constants';

export const clsPrefix = 'cap-aira-content';

export const MESSAGE_CHUNK = 'CHUNK';
export const MESSAGE_ATTRIBUTE = 'ATTRIBUTE';
export const MESSAGE_RENDER = 'RENDER';
export const MESSAGE_GET_SUGGESTIONS = 'GET_SUGGESTIONS';
export const MESSAGE_CONTENT_RECEIVED = 'CONTENT_RECEIVED';
export const N_CHOICES = 3;
export const LOADING_EMOJI = '⏳';
export const LOADING_TEXT = 'loading...';
export const MOCK_WS_URL = 'ws://ai-suggestion-mock-websocket';
export const WEBSOCKET_URL = `${WS_DOMAIN}/arya/api/v1/ask-aira-service/content_gen/get_ai_suggestions`;
